import { createTheme } from "@mui/material";

const theme = createTheme({
  palette: {
    primary: {
      main: "#67516C",
      contrastText: "#fff",
    },
    secondary: {
      main: "#373737",
      contrastText: "#fff",
    },
    background: {
      default: "#f3f3f3",
    },
  },
  typography: {
    fontFamily: "\"Jost\", Arial, sans-serif",
  },
  components: {
    MuiButton: {
      styleOverrides: {
        root: {
          borderRadius: 0,
          fontWeight: 700,
        },
      },
    },
  },
});

export default theme;
